import { INPUT_ERROR, INPUT_ERROR_NOT_VALID } from '@components/MainWidget/common/commonConstants'

export const validateRegNo = (regNo: string, regexPatternsData: string[]): boolean => {
  const formattedRegNo = regNo.replace(/[. ,:-]+/g, '')
  return regexPatternsData.some(pattern => new RegExp(pattern).test(formattedRegNo))
}

export const validateVehicleNumber = (regNo, regexPatternsData) => {
  if (!regNo) {
    return INPUT_ERROR
  } else if (!validateRegNo(regNo, regexPatternsData)) {
    return INPUT_ERROR_NOT_VALID
  }
  return false
}
